import React from 'react';
import LoginForm from "./LoginForm";

export default function Logins() {
  return (
      <section id="login" className="section contactus-section bg-container-login d-flex align-items-center justify-content-center min-vh-100">
        <div className="container w-100"  >
          <div className="contactus-box rounded overflow-hidden gray-bg shadow-lg p-4">
            <div className="contactus-title text-center">
              <h5>Manage & Activate </h5>
              <p className="m-0">Login to device</p>
            </div>
            <div className="contact-form mt-4">
              <LoginForm />
            </div>
          </div>
        </div>
      </section>
  );
}
